import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  questionText: {
    marginTop: "-3vh",
  },
});
